import { useEffect, useState, useContext } from 'react';

//Constantes
import { PRIMARY_COLOR, SECUNDARY_COLOR } from '../../constants/colors.js';

//Components
import FormActivo from '../../components/FormActivo/FormActivo.jsx';
import BarActivo from '../../components/BarActivo/BarActivo.jsx';

//Estilos
import './Control.css';

//Contextos
import activoContext from '../../context/activoContex/activoContex.js';
import productsContext from "../../context/productos/productsContext";
import authContext from "../../context/authentication/authContex";
import FormDuplicateLevels from '../../components/formDuplicateLevels/FormDuplicateLevels.js';

function Control(props) {

//Context de Autenticacion   
    const { usuario } = useContext(authContext);
//context activo
    const {getActivoByCodActivo, getFilesActivo, getDocFilesActivo, getFServFilesActivo} = useContext(activoContext);
//estado para controlar las Vistas en modo "Nuevo", "Edicion" o "Vista"
    const [modo, setModo] = useState("Nuevo");

/*---------Creadas desde Formateo de Componente----------------*/

//Recibira el item desde TreeActivo al ser este clickeado.
    const [activoToHandle,setActivoToHandle] = useState({}); 
    const [dataTypeList,setDataTypeList] = useState(null)   

    const [modalToShow, setModalToShow] = useState(null);

    //Context Add
    const ptContext = useContext(productsContext);
    const { products } = ptContext;
    
    //estado el cual seleccionas del menus desplegable un activo  
    const [onClickInfo, setOnClickInfo] = useState(false);
    //estado para ver el activo con el componente
    const [files, setFiles] = useState({general: [], qr: [], imagen: []});

//funcion para cuando selecciones un activo traiga sus datos  
    const handleOnClick = async (item, from='') => {
        try {
            const resp = await getActivoByCodActivo(item.codActivo)
            let activoObtenido = {...resp.activo,productos:resp.products};

            //S3
            const respfiles1 = await getFilesActivo(item.codActivo, 'general');

            const respfiles2 = await getFilesActivo(item.codActivo, 'imagen');

            const respDocFiles = await getDocFilesActivo(item.codActivo);

            const respFServFiles = await getFServFilesActivo(item.codActivo);

            let newFiles = {
                general:(respfiles1 == undefined) ? undefined : respfiles1.dato.files,
                imagen: (respfiles2 == undefined) ? undefined : respfiles2.dato.files,
                docFiles: respDocFiles || [],
                fServFiles: respFServFiles || []
            }

            
            // setFiles([respfiles1,respfiles2,respfiles3]);
            setFiles(newFiles);
            setOnClickInfo(true);
            setModo("Vista")
            setActivoToHandle(activoObtenido)
            if(from == "fromABMActivo") setModo('Edicion')
        } catch (error) {
            console.log("error", error);
        }
    }

  //Funcion de validacion (actToValide = activo a validar).
     const validacion =  (actToValidate,activoTypeSeleccionada,itemsListRec ) => { 
        
        if (actToValidate.codActivo === '') return 'Falta ingresar el codigo del activo';
        if (actToValidate.name === '') return 'Falta ingresar el nombre del activo';
        if (actToValidate.activoType == undefined || actToValidate.activoType === '' || actToValidate.activoType === null) return 'Falta ingresar el tipo del activo';                
        if(actToValidate.DEFAULTUNIMED == "") return 'Falta ingresar la unidad de medida default del activo'

        if(actToValidate.logsUbicaciones.length === 0){
            return 'Debe cargar un log en la subtabla Ubicaciones minimamente'
        }else{
            if (actToValidate.logsUbicaciones[0].nivel1.value === '' || actToValidate.logsUbicaciones[0].nivel1.value === null) return 'Complete Nivel1 del activo en subtabla Ubicaciones';
            for(const l of actToValidate.logsUbicaciones){
                if(l.user.value === '') return 'Complete el usuario en los logs de Ubicaciones';                            
            }
        }

        if(actToValidate.lecturas.length > 0){
            for(const lect of actToValidate.lecturas){
                if((lect.uniMed.value != 'DAYS' && lect.valor === '')) return 'Complete el valor para cada lectura en los logs de Lecturas'
            }
        }
        
        if (actToValidate.logsFServ.length == 0) return 'Debe cargar un log en la subtabla Disponibilidad minimamente'
        else{
            for(const l of actToValidate.logsFServ){
                if(l.user == undefined || l.user.value === '') return 'Complete el usuario en los logs de Disponibilidad';
                if(l.evento.value === '') return 'Complete el evento en los logs de Disponibilidad';
            }
        }

        const sistemasIncompletos = itemsListRec?.filter(i => !i?.sistema || !i?.sistema.name);
        if (sistemasIncompletos?.length > 0) return 'Falta completar el sistema del componente';

        const subsistemasIncompletos = itemsListRec?.filter(i => !i?.subsistema || !i?.subsistema.name);
        if (subsistemasIncompletos?.length > 0) return 'Falta completar el subsistema del componente';
        
        return '';    
    };

    return (
        <div className='controlDiv'>

           <BarActivo handleOnClick={handleOnClick} modalToShow={modalToShow} setModalToShow={setModalToShow}/>

            <div style={{flex: 1,maxHeight: "100%",overflow: "auto",backgroundColor: "white"}}>
                {
                    // el activo tiene datos
                    onClickInfo &&
                    <FormActivo handleOnClickEditar={handleOnClick} setActivoToHandle={setActivoToHandle} activoToHandle={activoToHandle} setOnClickInfo={setOnClickInfo} modo={modo} setModo={setModo} validacion={validacion} dataTypeList={dataTypeList} setDataTypeList ={setDataTypeList} products={products} usuario={usuario} files={files}                                         
                    />
                }
                {// el activo no tiene datos
                    !onClickInfo && 
                    <FormActivo activoToHandle={{}} setOnClickInfo={setOnClickInfo} modo={modo} setModo={setModo} validacion={validacion} dataTypeList={dataTypeList} setDataTypeList ={setDataTypeList} products={products} usuario= {usuario}                                                 
                    />
                }
                {
                    modalToShow?.action == 'DUPLICAR' && <FormDuplicateLevels data={modalToShow?.data} setModalToShow={setModalToShow}/>
                }
            </div>
        </div>
    );
}

export default Control;




